import { useFilterHotelContext } from "./filter-hotel.context";

export function FilterHotel() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterHotelContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}